// extracted by mini-css-extract-plugin
module.exports = {"lineWidthSlider":"LineWidthSlider_lineWidthSlider__2A7_q","item":"LineWidthSlider_item__1aplL"};